<template>
  <div>
    <v-container fluid>
      <div class="headline primary--text">Setting</div>
    </v-container>
    <v-container fluid>
      <v-layout align-center>
        <v-flex>
          <div class="headline primary--text">คะแนนจัดกลุ่มข้อความ</div>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn
            v-if="!showEditTrainingScore"
            icon
            outline
            color="primary"
            @click="showEditTrainingScore = true"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <div>
        ระดับคะแนนจะจัดกลุ่มข้อความไว้ในหน้า Auto training
        โดยระดับคะแนนจะมีผลแค่คำตอบที่บอทตอบไม่ได้ปัจจุบันเท่านั้น คำที่เคยเพิ่มไปแล้วจะไม่มีผล
      </div>

      <TrainingScoreSetting
        v-if="showEditTrainingScore"
        :training-config="trainingConfig"
        :max-score="maxScore"
        :min-score="minScore"
        @onSaveTrainingConfig="onSaveTrainingConfig"
        @onCancel="showEditTrainingScore = false"
      />
    </v-container>
    <v-divider />
    <v-container fluid>
      <v-layout align-center>
        <v-flex>
          <div class="headline primary--text">Auto training</div>
        </v-flex>
        <v-flex shrink class="text-xs-right">
          <ToggleButton
            :value="trainingConfig.auto_training"
            :sync="true"
            :color="$vuetify.theme.success"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            @change="handleToggleTraining('auto_training')"
          />
        </v-flex>
      </v-layout>
      <div>หากปิดการเก็บข้อมูลในหน้า Auto training จะไม่ทำการเก็บข้อมูล</div>
    </v-container>
    <v-divider />
    <!-- <v-container fluid>
      <v-layout align-center>
        <v-flex>
          <div class="headline primary--text">Ignored recommended</div>
        </v-flex>
        <v-flex shrink class="text-xs-right">
          <ToggleButton
            :value="trainingConfig.ignored"
            :sync="true"
            :color="$vuetify.theme.success"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            @change="handleToggleTraining('ignored')"
          />
        </v-flex>
      </v-layout>
      <div>
        หากปิดการใช้งาน การเก็บข้อมูลในหน้า Ignored recommended จะไม่ทำการเก็บข้อมูล
        โดยจะมีผลกับข้อความปัจจุบันเท่านั้น
      </div>
    </v-container>
    <v-divider />
    <v-container fluid>
      <v-layout align-center>
        <v-flex>
          <div class="headline primary--text">Spam recommended</div>
        </v-flex>
        <v-flex shrink class="text-xs-right">
          <ToggleButton
            :value="trainingConfig.spam"
            :sync="true"
            :color="$vuetify.theme.success"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            @change="handleToggleTraining('spam')"
          />
        </v-flex>
      </v-layout>
      <div>
        หากปิดการใช้งาน การเก็บข้อมูลในหน้า Spam recommended จะไม่ทำการเก็บข้อมูล
        โดยจะมีผลกับข้อความปัจจุบันเท่านั้น
      </div>
    </v-container> -->
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import { mapGetters } from 'vuex'
import TrainingScoreSetting from './TrainingScoreSetting'
export default {
  components: {
    ToggleButton,
    TrainingScoreSetting
  },
  props: ['trainingConfig'],
  data() {
    return {
      maxScore: 0.84,
      minScore: 0.5,
      showEditTrainingScore: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  async mounted() {},
  methods: {
    async handleToggleTraining(type) {
      this.$emit('onSaveTrainingConfig', {
        trainingConfig: {
          ...this.trainingConfig,
          [type]: !this.trainingConfig[type]
        }
      })
    },
    onSaveTrainingConfig(trainingConfig) {
      const vm = this
      vm.$emit('onSaveTrainingConfig', {
        trainingConfig,
        onSuccess: () => {
          vm.$swal({
            title: 'Successful',
            type: 'success'
          })
          vm.showEditTrainingScore = false
        },
        onError: () => {
          vm.$swal({
            title: 'Error',
            text: 'เกิดข้อผิดพลาดในการบันทึกข้อมูล',
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Training/Setting.vue